module.exports = __webpack_public_path__ + "static/media/18.3ce5af46.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/18.png
// module id = 799
// module chunks = 0